import { SpecializationDto } from "../../../../../Api/Model/SpecializationDto.csharp";

export const specializationInitialState: SpecializationDto = {
  id: "",
  name: "",
  description: "",
  specializationUrl: "",
  insuranceIconUrl: "",
  keywords: [],
};
